<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>
  <div
    *ngIf="!loading && !authInProgress && !authComplete"
    class="contents-wrapper"
  >
    <div class="contents-container">
      <div
        class="page-icon"
        *ngIf="state.paymentInformation.paymentMethod == 'INVOICE'"
      >
        <app-zaver-icon [size]="80" name="invoiceCircle"></app-zaver-icon>
      </div>
      <div
        class="page-icon"
        *ngIf="
          state.paymentInformation.paymentMethod == 'CREDIT' ||
          state.paymentInformation.paymentMethod == 'CREDIT_STATIC_AMOUNT'
        "
      >
        <app-zaver-icon [size]="80" name="cakeCircle"></app-zaver-icon>
      </div>

      <div
        class="page-text"
        *ngIf="state.paymentInformation.paymentMethod == 'INVOICE'"
      >
        Faktura – Betale innen
        {{
          selectedInstallmentOption
            ? selectedInstallmentOption.numberOfDaysUntilFinalDueDate
            : 14
        }}
        dager
      </div>
      <div
        class="page-text"
        *ngIf="
          state.paymentInformation.paymentMethod == 'CREDIT' ||
          state.paymentInformation.paymentMethod == 'CREDIT_STATIC_AMOUNT'
        "
      >
        Delbetaling kr {{ selectedInstallmentOption.monthlyCost }}/mnd i
        {{ selectedInstallmentOption.numberOfMonths }}
        måneder
      </div>
      <div
        class="page-sub-text"
        *ngIf="state.paymentInformation.paymentMethod == 'INVOICE'"
      >
        Basert på kredittvurderingen og dine identifiserte krav og behov kan vi
        tilby en faktura
        {{
          selectedInstallmentOption
            ? selectedInstallmentOption.numberOfDaysUntilFinalDueDate
            : 14
        }}
        dager.
      </div>
      <div
        class="page-sub-text"
        *ngIf="
          state.paymentInformation.paymentMethod == 'CREDIT' ||
          state.paymentInformation.paymentMethod == 'CREDIT_STATIC_AMOUNT'
        "
      >
        Basert på kredittvurderingen og dine identifiserte krav og behov kan vi
        tilby delbetaling opptil
        {{ selectedInstallmentOption.numberOfMonths }} måneder.
      </div>

      <div class="details">
        <hr class="details-divider" />
        <div class="details-container">
          <div class="details-key-entry">
            {{ state.paymentInformation.title }}
          </div>

          <zaver-button-link
            (click)="toggleModalSelectDetailsTab()"
            [text]="'Vis kjøp'"
          >
          </zaver-button-link>
        </div>

        <hr class="details-divider" />
        <div class="details-container">
          <div class="details-key-entry">Vilkår og betingelser</div>

          <zaver-button-link
            (click)="toggleModalSelectTermsTab()"
            [text]="'Vis detaljer'"
          >
          </zaver-button-link>
        </div>

        <hr class="details-divider" />
        <div
          class="details-container"
          *ngIf="state.paymentInformation.paymentMethod == 'INVOICE'"
        >
          <div class="details-key-entry">Totalbeløp</div>

          <div class="details-value-entry">
            {{ state.totalCheckoutValue | value }}
          </div>
        </div>
        <div
          class="multi-details-container"
          *ngIf="
            state.paymentInformation.paymentMethod == 'CREDIT' ||
            state.paymentInformation.paymentMethod == 'CREDIT_STATIC_AMOUNT'
          "
        >
          <div class="details-container">
            <div class="details-key-entry">Kredittbeløp</div>

            <div class="details-value-entry">
              {{ this.state.totalCheckoutValue | value }}
            </div>
          </div>

          <div class="sub-details-container">
            <div class="details-key-entry">Beløp å betale</div>

            <div class="details-value-entry">
              kr {{ selectedInstallmentOption.totalAmount }}
            </div>
          </div>
        </div>

        <hr class="details-divider" />
      </div>

      <div class="checkbox-container">
        <label class="checkbox-label">
          <zaver-checkbox [(ngModel)]="ctaActive"> </zaver-checkbox>
          <div *ngIf="state.paymentInformation.paymentMethod == 'INVOICE'">
            Avtalen er lest og forstått
          </div>
          <div
            *ngIf="
              state.paymentInformation.paymentMethod == 'CREDIT' ||
              state.paymentInformation.paymentMethod == 'CREDIT_STATIC_AMOUNT'
            "
          >
            Jeg har lest og forstått avtaler og tilknyttede kostnader for valgt
            løpetid.
          </div>
        </label>
      </div>

      <zaver-primary-button
        [text]="'Fullfør kjøp'"
        [disabled]="!ctaActive"
        [logo]="'assets/icon/BankID-Logo-NO-Symbol.svg'"
        (click)="handleCtaClick()"
      ></zaver-primary-button>

      <div *ngIf="authError" class="error">
        <span>Signeringen mislyktes, prøv på nytt</span>
      </div>
    </div>

    <div *ngIf="authInProgress || authComplete" class="contents-wrapper">
      <div class="contents-container">
        <div class="page-icon-loading">
          <app-zaver-icon [size]="32" name="bankIDno" ></app-zaver-icon>
        </div>
        <div class="loading-container">
          <div class="loading-text">{{ loadingText }}</div>
          <zaver-loading-dots [color]="'#b7bcc8'"></zaver-loading-dots>
        </div>
      </div>
    </div>
  </div>
</div>

<zaver-checkout-modal
  *ngIf="selectorItems && modalActive"
  [buttonText]="'Lukk'"
  [logo]="'assets/img/Zaver_Logotype_Circle_Coal_DE.svg'"
  (onClose)="toggleModal()"
>
  <app-selector
    #selector
    [selectedItem]="selectedItem"
    [selectorItems]="selectorItems"
  ></app-selector>
</zaver-checkout-modal>
